var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes()},[_c('div',{class:`${_vm.el}__loader`},[_c('svg',{class:`${_vm.el}__circular`,attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{class:{
          [`${_vm.el}__path`]: true,
          [`${_vm.el}__path--${_vm.color}`]: _vm.color,
        },attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"4","stroke-miterlimit":"10"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }